exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-app{background-color:#eff2f5}.my-app .my-pay .panel{height:1rem;line-height:1rem}.my-app .my-pay .table-row{height:1.5rem;padding:.3rem;border-bottom:none}.my-app .my-pay .mycol{padding-right:.613333rem;text-align:right}.my-app .my-pay .mycol .f-strongest{color:#ff0101}.my-item{border-bottom:.026667rem solid #e9e9e9;height:.933333rem;line-height:.933333rem}.my-item .item-table{width:100%}.my-item .item-name{color:#999;width:20%}.my-item .item-fee-value,.my-item .item-value{text-align:right;width:80%}.my-item .item-fee-value{color:#ff0101}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a910c57","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/hospitalCostList/inpatientCostList.vue
// module id = 433
// module chunks = 0